<div id="lnr-create-account-root">
  <ng-content select="[header]"></ng-content>
  <div class="form-area">
    <div class="form-header">
      <ng-content select="[form-header]"></ng-content>
    </div>
    <ng-content select="[businessRepresentativeForm]"></ng-content>
    <ng-content select="[isError]"></ng-content>
    <div class="button-section">
      <ng-content select="[buttonSection]"></ng-content>
    </div>
  </div>
</div>
